import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';

export default {
  ...cloneDeep(baseDefaults),
  title: `Almost complete`,
  titleColor: `white`,
  backgroundColor: 'white',
  barColor: '#387fc3',
  height: '10px',
  stripes: true,
  percentage: {
    value: 50,
    unit: '%',
  },
};
